import { dataSender } from '../../../../common/utils/router';
import { API_SERVER_URL } from '../../../../common/utils/utils';

export const skeleton = () => {
    return [
        {
            row: [30, 70],
            gap: 5,
            vertical: 'unset',
            items: [
                {
                    type: 'image'
                },
                {
                    content: [
                        {
                            row: [30, 60, 10],
                            vertical: 'unset',
                            items: [
                                {
                                    content: [
                                        {
                                            type: 'title',
                                            width: 80
                                        },
                                        {
                                            type: 'text'
                                        }
                                    ]
                                },
                                'empty',
                                {
                                    type: 'circle',
                                    align: 'right'
                                }
                            ]
                        },
                        {
                            type: 'blockLG'
                        },
                        {
                            type: 'blockLG'
                        }
                    ]
                }
            ]
        }
    ];
};

export const deleteEventFunction = (event, setReloadData, setEvents, userToken, lang) => {
    dataSender(
        `${API_SERVER_URL}/api/v1/user/event-calendar/${event.id}`,
        'DELETE',
        null,
        () => {
            setEvents(null);
            setReloadData((s) => !s);
        },
        () => {
            setEvents(null);
            setReloadData((s) => !s);
        },
        userToken,
        lang
    );
};
